// import NavBar from "../../Header/Navbar";
import ProductData from "./ProductData";
import Category from "./Categorydata";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "../../../styles.css";
const Products = () => {
  return (
    <>
      {/* <NavBar /> */}
      {Category?.map((item) => {
        return (
          <div key={item.id} className="mb-20 2xl:min-h-[51em] xl:min-h-[39em]">
            <div className="mb-10" id={item.id}>
              <img
                alt=""
                className="w-full hidden lg:block selection:"
                src={item.banner}
              ></img>
              <img
                alt=""
                className="w-full block lg:hidden selection:"
                src={item.mobileBanner}
              ></img>
            </div>
            <div className="w-full sm:w-4/5 mx-auto text-center">
              <p className="text-4xl font-semibold block">{item.name}</p>
              <div
              // className={
              //   "grid " +
              //   (item.id === "A" ? "xl:grid-cols-5" : "xl:grid-cols-6") +
              //   " grid-cols-2 md:grid-cols-4 mx-auto text-center my-8 p-4 rounded-lg gap-8 lg:gap-5"
              // }
              >
                <Swiper
                  slidesPerView={5}
                  spaceBetween={0}
                  loop={true}
                  breakpoints={{
                    0: {
                      slidesPerView: 2,
                    },
                    550: {
                      slidesPerView: 3,
                    },
                    700: {
                      slidesPerView: 3,
                    },
                    800: {
                      slidesPerView: 5,
                    },
                    // 1000: {
                    //   slidesPerView: 7,
                    // },
                  }}
                  navigation={true}
                  modules={[Navigation]}
                  className="mySwiper text-white mx-auto text-center my-9 p-4"
                  style={{
                    "--swiper-navigation-color": "#acacac",
                    "--swiper-navigation-size": "22px",
                  }}
                >
                  {ProductData?.map((elem, index) => {
                    return elem.categoryId === item.id ? (
                      // <div className="mx-auto" key={index}>
                      <SwiperSlide key={elem.id} className="inline-block ">
                        {" "}
                        <Link className="" to={`/products/${elem.id}`}>
                          <img
                            alt={elem.title}
                            src={elem.coverimg}
                            className={
                              "block w-5/6 " +
                              // (item.id === "A" ? "xl:w-4/5" : "lg:w-full") +
                              " transition ease-in-out hover:-translate-y-1 hover:scale-110 hover:mb-10"
                            }
                          ></img>
                          <p className="text-[14px] tracking-normal xl:text-base font-semibold block text-center my-4 rounded-[5px] px-4 lg:px-8 py-1">
                            {elem.title}
                          </p>
                        </Link>
                      </SwiperSlide>
                    ) : (
                      // </div>
                      <></>
                    );
                  })}
                </Swiper>
              </div>
              {/* <div className="flex flex-row mx-auto text-center my-8">
                {ProductData?.map((elem, index) => {
                  return elem.categoryId === item.id ? (
                    <div className="basis-1/3" key={index}>
                      <Link
                        className="grid justify-items-center"
                        to={`/products/${elem.id}`}
                      >
                        <img src={elem.coverimg} className="block w-3/5 "></img>
                        <p className="text-base font-semibold block text-center my-4">
                          {elem.title}
                        </p>
                      </Link>
                    </div>
                  ) : (
                    <></>
                  );
                })}
              </div> */}
            </div>
          </div>
        );
      })}
    </>
  );
};
export default Products;
